namespace Solovis.Reports.Parameters {

    export class CurrencyParameterControl extends Solovis.UI.BaseControl {
        public static hasNewRender = true;

        public initialParameterValue;
        public currentCurrency;

        public selectedCurrencyLabel;
        public selectCurrencyLink;
        public _selectionDialog;
        private _currencyOptions;

        private _portalServices: Solovis.Portal.IPortalServices;

        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this.currentCurrency = this.initialParameterValue;
        }


        public static preload(newValue, callback, portalServices: Solovis.Portal.IPortalServices) {
            if (!portalServices) {
                portalServices = new Solovis.Portal.SitePortalServices();
            }

            if (newValue && (newValue.id || newValue.code)) {
                let currencyDataRequest: any = {};
                if (Solovis.isNotNull(newValue.id)) {
                    currencyDataRequest.currencyId = newValue.id;
                }
                else if (newValue.code) {
                    currencyDataRequest.currencyCode = newValue.code;
                }

                portalServices.rpc().invoke(
                    "~/Selectors/CurrencySelector/GetCurrencyData", currencyDataRequest,
                    function (response, success) {
                        if (success) {
                            var currencyData = response.result;
                            callback(currencyData, true);
                        }
                        else {
                            callback(null, false);
                        }
                    });
            }
            else {
                callback(null, true);
            }
        }

        public static serializeParameterValue(value): any {
            if (value) {
                if (value.id) {
                    return { id: value.id };
                }
                else if (value.code) {
                    return { code: value.code };
                }
            }

            return null;
        }

        public static getLabel(value): any {
            return value?.code + " - " + value?.label;
        }

        private async doRenderNew() {
            const self = this;
            await Solovis.UX.Utils.placeComponent(
                "AsyncSelect",
                this.container[0],
                {
                    cacheOptions: true,
                    filterOption: (option, input) => {
                        return (option.label as string).toLowerCase().indexOf(input.toLowerCase()) > -1
                    },
                    loadOptions: () => new Promise(async (resolve, reject) => {
                        if (self._currencyOptions) {
                            return resolve(self._currencyOptions)
                        }

                        try {
                            //NOTE: load currency options, pulled from CurrencySelectorControl
                            const response = await this._portalServices.reportDataLoader().loadDataSetAsync(
                                "/Solovis/Metadata/ModelEnvironment",
                                { currencyOptions: { loadAll: true } });

                            var modelEnv = new InvData.ModelEnvironment();
                            modelEnv.mergeEnvironmentData(response.result.dataSet.modelEnvironment);
                            const currencyList = modelEnv.currencies.itemList.sort((a, b) => (a.code as string).localeCompare(b.code));
                            self._currencyOptions = currencyList;
                            resolve(currencyList);
                        } catch (e) {
                            reject(e);
                        }
                    }),
                    defaultValue: this.currentCurrency,
                    getOptionLabel: (currency) => `${currency.code} - ${currency.label}`,
                    getOptionValue: (currency) => currency.id,
                    onChange: (currency) => {
                        this.currentCurrency = currency;
                        this.notifyParameterValueChanged();
                    },
                }
            );
        }


        private doRenderClassic() {
            var self = this;

            this.selectedCurrencyLabel = $("<span>").appendTo(this.container);
            this.selectCurrencyLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

            Solovis.UI.DomHelper.focusableClick(this.selectCurrencyLink, function () {
                self._toggleSelectorDialog(function (currency) {
                    self._setCurrentCurrencyData(currency);
                    self.notifyParameterValueChanged();
                });
            });

            // Set initial parameter value text.
            if (this.currentCurrency) {
                this._setCurrentCurrencyData(this.currentCurrency);
            }
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }
        
        public _setCurrentCurrencyData(currencyData) {
            this.currentCurrency = currencyData;
            if (this.currentCurrency) {
                this.selectedCurrencyLabel.text(CurrencyParameterControl.getLabel(this.currentCurrency) + " ");
            }
            else {
                this.selectedCurrencyLabel.text("");
            }
        }

        public setParameterValue(newValue, more) {
            Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
                this, CurrencyParameterControl, this._setCurrentCurrencyData, newValue, more);
        }

        public getParameterValue() {
            if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
                return this.initialParameterValue ? this.initialParameterValue : null;
            }
            else if (this.currentCurrency) {
                return Solovis.deepCopy(this.currentCurrency);
            }
            else {
                return null;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }


        public _toggleSelectorDialog(selectionCallback) {
            var self = this;

            if (this._selectionDialog) {
                // We already have the selection dialog open, so close it.
                this._selectionDialog.close();
                this._selectionDialog = null;
                return;
            }

            var currencySelectorControlHostDiv = $("<div>");
            var currencySelectorControlHost = new Solovis.UI.ControlHost({ container: currencySelectorControlHostDiv });
            var currencySelectorControl = new Solovis.InvDataSelectors.CurrencySelectorControl({
                controlHost: currencySelectorControlHostDiv,
                portalServices: this._portalServices,
                initialValue: this.currentCurrency ? this.currentCurrency : null,
                selectionCallback: function (currency) {
                    selectionCallback(currency);
                    self._selectionDialog.close();
                },
                cancelCallback: function () {
                    self._selectionDialog.close();
                }
            });
            currencySelectorControlHost.setCurrentControl(currencySelectorControl);

            // Determine dialog position.        
            var linkOffset = $(this.selectedCurrencyLabel).offset();
            var linkHeight = $(this.selectCurrencyLink).outerHeight();
            var dialogPosition = {
                left: linkOffset.left,
                top: linkOffset.top + linkHeight + 5
            };

            var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

            var desiredWidth = Math.min($(window).width() * .8, 250);
            var desiredHeight = Math.min($(window).height() * .8, 300);

            var minWidth = 100;
            var minHeight = 100;


            this._selectionDialog = new Solovis.UI.Dialog({
                container: currencySelectorControlHostDiv,
                ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

                title: false,
                autoOpen: true,
                destroyOnClose: true,
                actions: ["Close"],
                noAnimation: true,
                position: adjustedPosition,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,

                buttons: [
                    {
                        label: "Clear",
                        click: function () {
                            selectionCallback(null);
                            self._selectionDialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._selectionDialog.close();
                        }
                    }
                ],

                resize: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    currencySelectorControl.setAvailableHeight(overallHeight);
                },

                activate: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    currencySelectorControl.setAvailableHeight(overallHeight);
                },

                deactivate: function () {
                    self._selectionDialog = null;
                }
            });
        }
    }

}
